import styled from "styled-components";

export const RoundedVoxCTAContainer = styled.div<{ $disabled: boolean }>`
    padding: 20px 32px;
    border: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : null};
    border-radius: 10px;
    margin-bottom: 10px;

    @media (hover: hover) {
        &:hover {
        cursor: ${({ $disabled }) => $disabled ? 'initial' : 'pointer'};
        box-shadow: ${({ $disabled }) => $disabled ? undefined : '0px 8px 20px rgba(0, 0, 0, 0.2)'};
        }
    }
`;

export const RoundedBoxCTAWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div {
        display: inline-flex;

        &:first-child {
            display: flex;
            align-items: center;

            > * {
                &:first-child {
                    margin-right: 12px;
                }
            }
        }
    }
`;

export const SecondaryTextWrapper = styled.div`
    max-width: calc(100% - 10px);
    margin-top: 5px;
`;